<div *ngIf="!props.isHidden">
    <label class="form-label fg-label my-3" for="{{ props.field_Name }}">{{ props.label }} <span class="text-danger"
            *ngIf="props.required">*</span></label>
    <angular-editor [placeholder]="props.placeholder" required formControlName="{{ props.field_Name }}"
        maxlength="{{ props.maxlength }}" minlength="{{ props.minlength }}" [config]="editorConfig"></angular-editor>
    <!-- <sm-error [control]="formcontrol"></sm-error> -->
    <sm-error [control]="formcontrol" [label]="props.label"></sm-error>

</div>